import { roomShapes, roomTypes } from '../../api/constants'
import townService from '../../api/townService'

// initial state
const state = {
  town: null,
  type: null,
  shape: null,
  height: null,
  area: null,
  numOfDoors: null,
  numOfSmallWindows: null,
  numOfLargeWindows: null,
  description: null,
  operationType: null
}

// getters
const getters = {
  numOfWindowsStr(state) {
    if(state.numOfLargeWindows == null || state.numOfSmallWindows == null) {
      return null
    }
    return `Isoja: ${state.numOfLargeWindows} kpl|Pieniä: ${state.numOfSmallWindows} kpl`
  },

  isComplete(state) {
    let complete =
      state.town != null &&
      state.shape != null &&
      state.height != null &&
      state.area != null &&
      state.numOfDoors != null &&
      state.numOfSmallWindows != null &&
      state.numOfLargeWindows != null
    return complete
  },

  apiParams(state) {
    const costMultiplier = state.town.costIndex / 100.0;

    return {
      type: state.type ? state.type.value : null,
      townCode: state.town.code,
      height: state.height,
      area: state.area,
      shape: state.shape.value,
      numOfDoors: state.numOfDoors,
      numOfSmallWindows: state.numOfSmallWindows,
      numOfLargeWindows: state.numOfLargeWindows,
      description: state.description,

      costMultiplierWork: costMultiplier,
      costMultiplierMaterial: 1,
      costMultiplierSubcontracting: costMultiplier,
      costMultiplierEquipment: costMultiplier,
      costMultiplierOther: costMultiplier
    }
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  SET_OPERATION_TYPE(state, operationType) {
    state.operationType = operationType
  },
  SET_TOWN(state, town) {
    state.town = town
  },
  SET_TYPE(state, type) {
    state.type = type
  },
  SET_SHAPE(state, shape) {
    state.shape = shape
  },
  SET_AREA(state, area) {
    state.area = area
  },
  SET_HEIGHT(state, height) {
    state.height = height
  },
  SET_NUM_OF_DOORS(state, numOfDoors) {
    state.numOfDoors = numOfDoors
  },
  SET_NUM_OF_SMALL_WINDOWS(state, numOfSmallWindows) {
    state.numOfSmallWindows = numOfSmallWindows
  },
  SET_NUM_OF_LARGE_WINDOWS(state, numOfLargeWindows) {
    state.numOfLargeWindows = numOfLargeWindows
  },
  SET_DESCRIPTION(state, description) {
    state.description = description
  },
  SET_FROM_CALCULATION(state, calculation) {
    state.town = townService.getTownByCode(calculation.params.townCode)
    state.type = roomTypes.find(type => type.value == calculation.params.type)
    state.shape = roomShapes.find(shape => shape.value == calculation.params.shape)
    state.area = calculation.params.area
    state.numOfDoors = calculation.params.numOfDoors
    state.numOfSmallWindows = calculation.params.numOfSmallWindows
    state.numOfLargeWindows = calculation.params.numOfLargeWindows
    state.height = calculation.params.height
    state.description = calculation.params.description
  },
  CLEAR(state) {
    state.town = null
    state.type = null
    state.shape = null
    state.height = null
    state.area = null
    state.numOfDoors = null
    state.numOfSmallWindows = null
    state.numOfLargeWindows = null
    state.description = null
    state.operationType = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/roomParams.js